import axios from "axios";
import { createAsyncThunk, createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../common/store/store";
import { Location } from "./Location";

const LOCATIONS_API_URL = `${process.env.REACT_APP_API_BASE_URL}/locations`;

const locationsAdapter = createEntityAdapter<Location>({});

const initialState = locationsAdapter.getInitialState();

const locationsSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchLocations.fulfilled, (state, action) => {
      locationsAdapter.setAll(state, action.payload);
    });
  },
});

export const fetchLocations = createAsyncThunk("locations/fetchLocations", async () => {
  try {
    const response = await axios.get(`${LOCATIONS_API_URL}`);
    const locations: Location[] = response.data.map(mapApiLocation);
    return locations;
  } catch (error) {
    return [];
  }
});

export const mapApiLocation = (location: any): Location => ({
  id: `${location.id}`,
  name: location.name,
});

export const { selectAll: selectAllLocations } = locationsAdapter.getSelectors((state: RootState) => state.locations);
export const selectLocationById = createSelector(
  selectAllLocations,
  (state: RootState, locationId: string) => locationId,
  (locations, locationId) => locations.find((location) => location.id === locationId)
);
export const selectLocationsByIds = createSelector(
  selectAllLocations,
  (state: RootState, locationIds?: string[]) => locationIds,
  (locations, locationIds) => locations.filter((location) => locationIds?.includes(location.id))
);
export const selectLocationsBySearchTerm = createSelector(
  selectAllLocations,
  (_state: RootState, searchTerm: string) => searchTerm.toLowerCase(),
  (locations, searchTerm) => locations.filter((location) => location.name.toLowerCase().includes(searchTerm))
);

export default locationsSlice.reducer;
